/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Clear_Bird_DiveInputs */

const en_quiet_clear_bird_dive = /** @type {(inputs: Quiet_Clear_Bird_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const de_quiet_clear_bird_dive = /** @type {(inputs: Quiet_Clear_Bird_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigen`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Quiet_Clear_Bird_DiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_clear_bird_dive = /** @type {((inputs?: Quiet_Clear_Bird_DiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Clear_Bird_DiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_clear_bird_dive(inputs)
	return de_quiet_clear_bird_dive(inputs)
});